/***************************************************************************
 *
 * SCRIPT JS
 *
 ***************************************************************************/
$(document).on('turbolinks:load', function() {
    setTimeout("$('.notice').fadeOut('slow')", 5000);
});
$(document).on('turbolinks:load', function() {
    setTimeout("$('.alert').fadeOut('slow')", 5000);
});

$(document).on('turbolinks:load', function() {
    //data-hrefの属性を持つtrを選択しclassにclickableを付加
    $('tr[data-href]').addClass('clickable')
    .click(function(e) {
        if(!$(e.target).is('a')){
            window.location = $(e.target).closest('tr').data('href');}
    });
});

// 規約同意時にボタンを活性化させる
window.agree_to_policy = function () {
    if($("#agreement").prop("checked") == true && $("#contraction_agreement").prop("checked") == true) {
        $("#register-plan").prop("disabled", false);
        document.getElementById("register-card-disabled").style.display ="none";
        document.getElementById("register-card").style.display ="block";
    } else {
        $("#register-plan").prop("disabled", true);
        document.getElementById("register-card-disabled").style.display ="block";
        document.getElementById("register-card").style.display ="none";
    }
}